import React, { FC } from 'react';
import { useParams } from 'react-router';
import { EditResults } from './edit-results';

export const EditResultsNavigation: FC = (): JSX.Element => {
  let params = useParams();

  return <EditResults dayIndex={Number(params.dayIndex || '1')} selectedTournamentIndex={Number(params.tournamentIndex)} />;
};
